export enum LoginMethod {
  Facebook = 'Facebook',
  Google = 'Google',
  Password = 'Password',
}
